<woa-modal-page-layout [title]="'woa.heading.feedback.title'">
    @if (sent()) {
        <woa-content-message [level]="MessageLevel.SUCCESS"
                             [text]="'woa.message.feedback.thanks'"></woa-content-message>
    } @else {
        <woa-form (onSubmit)="send()">
            <woa-selection-field [(ngModel)]="category" name="category" required [showNone]="false"
                                 [label]="'woa.label.feedback.category'"
                                 [placeholder]="'woa.label.feedback.categoryPlaceholder'">
                @for (category of configurationModel.app()?.feedbackCategories; track category) {
                    <woa-option [value]="category.categoryName"></woa-option>
                }
            </woa-selection-field>
            <woa-text-area-field [(ngModel)]="message" name="message" required
                                 [label]="'woa.label.feedback.message'"
                                 [placeholder]="'woa.label.feedback.messagePlaceholder'"></woa-text-area-field>
        </woa-form>
    }
    @if (sent()) {
        <woa-button woa-page-footer-control [label]="'woa.button.common.ok'"
                    [prominence]="ButtonProminence.LOW" (onActivate)="dismiss()"></woa-button>
    } @else {
        <woa-button woa-page-footer-control [label]="'woa.button.common.send'"
                    (onActivate)="form()?.submit()"></woa-button>
    }
</woa-modal-page-layout>
